import React from 'react'
import { connect } from 'react-redux'
import Textbox from '../components/Textbox'

const HomeNotification = ({ documents, user }) => (
  documents && documents.home ?
    <div>
      <Textbox 
        text = {documents.home.text}
        editable = {user.admin}
        editLink = '/document/edit/home'
        nonBackground = {true}
      />
    </div>
  :
    null
)

export default connect(
  state => ({ 
    user: state.user, 
    documents: state.documents
  }),
)(HomeNotification)



// WEBPACK FOOTER //
// ./src/components/HomeNotification.js